import { useEffect, useRef, useState } from "react";
import "./messageList.css";
import { useGlobalContext } from "../../../Context/Context";
import { format } from "date-fns";
import axios from "axios";

const MessageList = ({ setCurrentChat, setCheckBack, selectedCompany }) => {
  const { loggedUser, apiKey } = useGlobalContext();
  const { baseUrl } = useGlobalContext();
  const lastDate = useRef();
  const interval = useRef();
  lastDate.current = format(new Date(), "MM");

  const [dataChat, setDataChat] = useState([]);

  const handleSelectMessage = async (message) => {
    console.log(message);
    const handleBackMessage = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/chat/getAllMessages.php`,
          {
            chat_room_id: parseInt(message.id),
            api_key_company: selectedCompany.external_api_key,
            external_user_id: selectedCompany.company_chat_profile_id,
          }
        );
        console.log(data);
        if (data.status === 200) {
          let newMessages = { ...message, messages: data.messages };

          setCurrentChat(newMessages);
          setCheckBack(true);
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }
    };

    handleBackMessage();

    // Set interval to check for new messages every 10 seconds
    interval.current = setInterval(handleBackMessage, 10000);
  };

  useEffect(() => {
    console.log(selectedCompany);
    const fetchMessageList = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/chat/getChatRoomsForExternalUser.php`,
          {
            external_user_id: selectedCompany.company_chat_profile_id,
            api_key_company: selectedCompany.external_api_key,
          }
        );
        console.log(data);
        if (data.status === 200) {
          setDataChat(data.data);
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }
    };
    fetchMessageList();
    return () => {
      clearInterval(interval.current);
    };
  }, []);

  return (
    <div className="message-list">
      {dataChat !== null &&
        dataChat.map((message) => {
          const time = new Date(message.last_message_time);
          const hours =
            time.getHours() < 10 ? `0${time.getHours()}` : time.getHours();
          const minutes =
            time.getMinutes() < 10
              ? `0${time.getMinutes()}`
              : time.getMinutes();
          const day = format(time, "dd.MM.yyyy");
          const isCurrent =
            lastDate.current === format ||
            lastDate.current !== format(time, "MM");
          if (isCurrent) lastDate.current = format(time, "MM");
          return (
            <>
              {format(time, "dd.MM.yyyy") !==
                format(new Date(), "dd.MM.yyyy") &&
                isCurrent && <span className="time-span">{day}</span>}
              <div
                key={message.id}
                className="message-element"
                onClick={() => handleSelectMessage(message)}
              >
                <div className="wrapper-message-user">
                  <div className="wrapper-data-info">
                    <div
                      className="count-message"
                      style={{
                        backgroundColor: message.firstTime ? "red" : "green",
                      }}
                    >
                      {message.unseen_messages_count}
                    </div>
                    <div className="name-message">{message.name}</div>
                    <div className="time-message">{`${hours}:${minutes} `}</div>
                  </div>
                  <div className="wrapper-data-info">
                    <div className="text-message">{message.last_message}</div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
    </div>
  );
};

export default MessageList;
